import { queryClient } from '~/client/queryClient';
import { Company, CompanyQueryKeys, CompanyUser } from '~/types/company';
import { User } from '~/types/user';

/**
 * Event-time snapshot of the cached company-user features for analytics/Sentry payloads.
 * Cache-only read: returns undefined when the company-user is not loaded yet.
 */
export const getCachedCompanyUserFeatures = (companyId: Company['id'], userId: User['id']) =>
  queryClient
    .getQueryData<CompanyUser | null>(CompanyQueryKeys.companyUser(companyId, userId))
    ?.featuresV2?.map((feature) => feature.value);
